import type { RootState } from '../rootReducer';

export const selectIsShowMobileCoupon = (state: RootState) => state.sportCoupon.showMobileCoupon;
export const selectCouponPreviewState = (state: RootState) => state.sportCoupon.showCouponPreview;
export const selectIsCouponSumChanged = (state: RootState) => state.sportCoupon.isCouponSumChanged;
export const selectCouponTab = (state: RootState) => state.sportCoupon.couponTab;
